import { useEffect } from 'react';
import { PostModel } from '../../data-layer/posts/types';
import { truncateText } from '../../utils/truncateText';

const MAX_NAME_LENGTH = 25;
const SCRIPT_ID = 'post-video-meta';

const deleteVideoMetaScript = () => {
    const script = document.getElementById(SCRIPT_ID);
    if (script) {
        script.remove();
    }
};

export const usePostVideoMeta = (post?: PostModel) =>
    useEffect(() => {
        if (!post || post.content[0].type !== 'video') {
            return;
        }

        const ldJson = {
            '@context': 'http://schema.org',
            '@type': 'VideoObject',
            name: truncateText(post.text, MAX_NAME_LENGTH),
            description: post.text,
            uploadDate: post.createdAt,
            thumbnailUrl: post.content[0].media[0].firstFrameUrl,
            contentUrl: post.content[0].media[0].url,
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(ldJson);
        script.id = SCRIPT_ID;
        document.head.appendChild(script);

        return () => deleteVideoMetaScript();
    }, [post]);
